/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Cies_TitleInputs */

const es_marketplace_seo_galicia_guide_cies_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barco a las Islas Cíes desde Vigo y Sanxenxo`)
};

const gl_marketplace_seo_galicia_guide_cies_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barco ás Illas Cíes dende Vigo e Sanxenxo`)
};

const en_marketplace_seo_galicia_guide_cies_title = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Cies_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat to Cíes islands from Vigo and Sanxenxo`)
};

/**
* | output |
* | --- |
* | "Boat to Cíes islands from Vigo and Sanxenxo" |
*
* @param {Marketplace_Seo_Galicia_Guide_Cies_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_cies_title = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Cies_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Cies_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_cies_title(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_cies_title(inputs)
	return es_marketplace_seo_galicia_guide_cies_title(inputs)
});